export interface utilsStateInterface {
  firebase: any
  language: Language
  googleAuthProvider: any
  recaptchaProvider: any
  tngAccess: boolean
}

export enum Language {
  EN = "English",
  BM = "Malay",
  CH = "Chinese",
}

const initState: utilsStateInterface = {
  firebase: null,
  language: Language.EN,
  googleAuthProvider: null,
  recaptchaProvider: null,
  tngAccess: false,
}

const utilsReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_FIREBASE":
      return {
        ...state,
        firebase: action.payload.firebase,
      }
    case "UPDATE_LANGUAGE":
      return {
        ...state,
        language: action.payload.language,
      }
    case "UPDATE_GOOGLE_AUTH_PROVIDER":
      return {
        ...state,
        googleAuthProvider: action.payload.googleAuthProvider,
      }
    case "UPDATE_RECAPTCHA_PROVIDER":
      return {
        ...state,
        recaptchaProvider: action.payload.recaptchaProvider,
      }
    case "UPDATE_TNG_ACCESS":
      return {
        ...state,
        tngAccess: action.payload.tngAccess,
      }
    default:
      return state
  }
}

export default utilsReducer
